export const INDO_CHINESE_MENU = {
    section1: [
        {
            name: 'Samosa',
            correct: false,
            message: [
                `You should avoid anything that's fried.`,
                `Please make a different selection from the list of Starters.`
            ]
        },
        {
            name: 'Masala Peanuts',
            correct: true,
            message: [
                `This protein packed starter makes use of a number of spices to create a healthy and tastey snack.`,
                `Just be aware that they can be salty if you are watching sodium levels.`,
            ]
        },
        {
            name: 'Chicken Tikka Salad',
            correct: true,
            message: [
                `This salad is high in protein and incorporates non-starchy vegetables, yogurt and lots of spices for a healthy and flavorful starter.`,
            ]
        },
        {
            name: 'Chili Paneer',
            correct: false,
            message: [
                `(Deep Fried Battered Indian Cheese Cubes)`,
                `You should avoid anything that's breaded and fried.`,
                `Please make a different selection from the list of Starters.`
            ]
        },
        {
            name: 'Gobi Manchurian',
            correct: false,
            message: [
                `(Deep Fried Battered Cauliflower)`,
                `Although it is made with a non-starchy vegetable, this dish is batered and fried.`,
                `Try some steamed cauliflower sprinkled with garam masala and chili powder instead.`
            ]
        },
    ],
    section2: [
        {
            name: `Chicken Tikka Masala`,
            correct: false,
            message: [
                `This popular dish is high in fat.`,
                `If you're really craving the flavors of tikka masala you may want to try ordering the tikka masala salad from the starter menu and selecting a healthier option for your entrée.`
            ]
        },
        {
            name: `Shrimp Curry`,
            correct: false,
            message: [
                `This dish is deceptively high in fat. Ask for steamed shrimp with dipping sauce on the side.`,
            ]
        },
        {
            name: `Spinach Dal`,
            correct: true,
            message: [
                `Not only does spinach dal have a healthy dose of a non-starchy vegetable, it is also high fiber which helps regulate glucose absorbtion.`,
            ]
        },
        {
            name: `Lamb Vindaloo`,
            correct: false,
            message: [
                `Tempting as it is, this dish is pure meat and potatoes, so it is higher in carbohydrates.`,
                `Try selecting a dish based on non-startchy vegetables instead.`
            ]
        },
        {
            name: `Tandoori Vegetable`,
            correct: true,
            message: [
                `Making use of a variety of starchy and non-starchy vegetables, this dish is not only full of flavor but it is also high in fiber.`,
            ]
        }
    ],
    section3: [
        {
            name: `Naan (Regular or Garlic)`,
            correct: false,
            message: [
                `Traditional nann is low in fiber.`,
                `A better choice would be roti.`
            ]
        },
        {
            name: `Roti`,
            correct: true,
            message: [
                `(Unleavened bread made with whole wheat flour)`,
                `This whole wheat flour bread is higher in fiber which makes it a great accompanyment to your meal.`
            ]
        },
        {
            name: `Sweet Corn Soup`,
            correct: true,
            message: [
                `A great selection for a side dish, this soup is full of flavor.`,
            ]
        },
        {
            name: `Chenna Masala`,
            correct: true,
            message: [
                `(Chickpeas, tomato sauce, onion)`,
                `High in protein and fiber, chenna masala is a nutritious option.`
            ]
        },
        {
            name: `Medhu Vada`,
            correct: false,
            message: [
                `(Deep fried lentil patties)`,
                `Although the lentils are a health source of protein and fiber, deep frying adds unwanted carbohydrates, fats and calories.`
            ]
        }
    ],
    section4: [
        {
            name: `Traditional Egg Roll`,
            correct: false,
            message: [
                `Egg roles are deep fried, so they aren't the healthiest option on the menu.`,
                `Make another selection!`
            ]
        },
        {
            name: `Hot and Sour Soup`,
            correct: true,
            message: [
                `This soup is full of flavor and low in calories.`,
                `Just make sure to watch your sodium intake on the rest of your meal if you order this dish.`
            ]
        },
        {
            name: `Wonton Soup`,
            correct: false,
            message: [
                `The wontons in this soup add a lot of fat and carbohydrates that you don't need.`,
                `Try a different choice.`
            ]
        },
        {
            name: `Chinese Cabbage Salad`,
            correct: true,
            message: [
                `Cabbage is a great non-startchy vegetable so ordering this salad is a great way to start your meal.`,
                `You should limit the amount you eat, like only eating half of a 6' sandwich. Opting for whole grain bread and eating it open-faced are great ways to improve this choice.`
            ]
        },
        {
            name: `Pork Dumplings`,
            correct: false,
            message: [
                `Pork dumplings are high in carbs and fat, so steer clear of this option.`,
            ]
        }
    ],
    section5: [
        {
            name: `American Chop Suey`,
            correct: false,
            message: [
                `(Crispy noodles with sweet and sour vegetables)`,
                `Even though Chop Suey is full of vegetables, the traditional noodles are deep fried and the sauce contains a lot of sugar.`,
                `There are better choices on the menu!`
            ]
        },
        {
            name: `Chicken Fried Rice`,
            correct: false,
            message: [
                `Chicken fried rice may seem like a light dish, but it contains a large amount of carbohydrates and fat.`,
            ]
        },
        {
            name: `Vegetable Manchurian`,
            correct: false,
            message: [
                `(Deep fried vegetable dumplings cooked in soy sauce)`,
                `Deep fried anything isn't a good fit for a healthy diet.`,
                `Take a pass on this entrée.`
            ]
        },
        {
            name: `Egg Biryani`,
            correct: true,
            message: [
                `(hardboiled egg served with vegetables and long grain rice)`,
                `This dish is high in protein and delivers a serving of vegetables along with the long grain rice for a nicely balanced meal.`
            ]
        },
        {
            name: `Vegetable Hakka Noodles`,
            correct: false,
            message: [
                `(Fried noodles with vegetables and soy sauce)`,
                `The fried noodles in this dish make it a less than healthy option.`,
                `Try substituting a noodle that isn't fried, and watch out for the soy sauce if you're limiting your sodium intake.`
            ]
        }
    ],
    section6: [
        {
            name: `Regular Soda`,
            correct: false,
            message: [
                `Just as with the plating method at home, you want to avoid regular soda due to the sugar content.`,
                `Opt for a sugar-free or diet option instead. Please make a different Drink selection.`
            ]
        },
        {
            name: `Diet Soda`,
            correct: true,
            message: [
                `While not as beneficial as milk or water, diet or sugar free soda is an okay choice.`,
            ]
        },
        {
            name: `Sweet Tea`,
            correct: false,
            message: [
                `Tea may seem like it's better than regular soda, but with sweet tea you're often getting a lot more added sugar than you really should.`,
                `Opt for unsweetened instead if you're having tea. Please make a different Drink selection.`
            ]
        },
        {
            name: `Iced Tea`,
            correct: true,
            message: [
                `Iced tea is a fine choice as long as it's unsweetened.`,
                `If you prefer to have your tea with some sweetness, ask for a sugar substitute when you order.`
            ]
        },
        {
            name: `Water`,
            correct: true,
            message: [
                `Water is a no-brainer when it comes to keeping your body hydrated.`,
                `The plating method suggests pairing a glass of milk with your meal, but water is also a perfectly acceptable choice when dining out somewhere.`
            ]
        }
    ],
    congrats: `CONGRATULATIONS!!! You’ve demonstrated that you understand the plate method well enough to make smart choices the next time you visit an Indo-Chinese style restaurant.`
}
